// 24px stroke icon set from the Figma file (SCREEN-SPECS.md "Icons").
import type { SVGProps } from "react";

export type IconName =
  | "play" | "pause" | "prev" | "next" | "plus" | "comment" | "share" | "upload" | "mic" | "more" | "check"
  | "search" | "folder" | "bell" | "edit" | "trash" | "move" | "board" | "rooms" | "inbox" | "library" | "close" | "download" | "loop" | "chevron";

const F = { fill: "currentColor", stroke: "none" } as const;

const PATHS: Record<IconName, React.ReactNode> = {
  play: <path {...F} d="M7 4.5v15l13-7.5z" />,
  pause: (<><rect {...F} x="6" y="5" width="4" height="14" rx="1" /><rect {...F} x="14" y="5" width="4" height="14" rx="1" /></>),
  prev: (<><path {...F} d="M18 5L8 12l10 7z" /><path d="M6 5v14" /></>),
  next: (<><path {...F} d="M6 5l10 7-10 7z" /><path d="M18 5v14" /></>),
  plus: <path d="M12 5v14M5 12h14" />,
  comment: <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.4A8 8 0 1 1 21 12z" />,
  share: (<><path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7" /><path d="M16 6l-4-4-4 4" /><path d="M12 2v13" /></>),
  upload: (<><path d="M12 16V4" /><path d="M7 9l5-5 5 5" /><path d="M4 20h16" /></>),
  mic: (<><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0 0 14 0" /><path d="M12 18v3" /></>),
  more: (<><circle {...F} cx="5" cy="12" r="1.6" /><circle {...F} cx="12" cy="12" r="1.6" /><circle {...F} cx="19" cy="12" r="1.6" /></>),
  check: <path d="M5 12l5 5 9-10" />,
  search: (<><circle cx="11" cy="11" r="7" /><path d="M20 20l-4-4" /></>),
  folder: <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />,
  board: (<><rect x="3" y="4" width="5" height="16" rx="1.5" /><rect x="10" y="4" width="5" height="11" rx="1.5" /><rect x="17" y="4" width="4" height="7" rx="1.5" /></>),
  rooms: <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.4A8 8 0 1 1 21 12z" />,
  inbox: (<><path d="M4 13l2.5-7h11l2.5 7v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" /><path d="M4 13h5l1 2h4l1-2h5" /></>),
  library: <path {...F} d="M7 4.5v15l13-7.5z" />,
  close: <path d="M6 6l12 12M18 6L6 18" />,
  download: (<><path d="M12 4v12" /><path d="M7 11l5 5 5-5" /><path d="M4 20h16" /></>),
  loop: (<><path d="M17 2l4 4-4 4" /><path d="M3 11V9a3 3 0 0 1 3-3h15" /><path d="M7 22l-4-4 4-4" /><path d="M21 13v2a3 3 0 0 1-3 3H3" /></>),
  chevron: <path d="M6 9l6 6 6-6" />,
  bell: (<><path d="M6 9a6 6 0 0 1 12 0c0 5 2 7 2 7H4s2-2 2-7" /><path d="M10 20a2 2 0 0 0 4 0" /></>),
  edit: (<><path d="M4 20h4L19 9l-4-4L4 16z" /><path d="M14 6l4 4" /></>),
  trash: (<><path d="M4 7h16" /><path d="M9 7V4h6v3" /><path d="M6 7l1 13h10l1-13" /></>),
  move: (<><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><path d="M10 13h6" /><path d="M13 10l3 3-3 3" /></>),
};

export function Icon({ name, size = 20, ...rest }: { name: IconName; size?: number } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...rest}
    >
      {PATHS[name]}
    </svg>
  );
}
